import { ThumbsDown, ThumbsUp } from "@/assets/icons";
import type { AlfredFeedbackButtonsPropsInterface } from "@/interfaces/alfred";
import { generateValidClassNameHandler } from "@/lib/utils";
import { Button } from "@/ui/button";

/**
 * AlfredFeedbackButtons - Thumbs up/down feedback buttons for messages
 */
export const AlfredFeedbackButtons = ({
    currentFeedback,
    disabled = false,
    messageId,
    onFeedback,
}: AlfredFeedbackButtonsPropsInterface) => (
    <div className="flex items-center gap-1">
        <Button
            aria-label="Helpful"
            disabled={disabled}
            size="icon"
            variant="ghost"
            className={generateValidClassNameHandler(
                "size-6 p-0",
                currentFeedback === "positive" && "text-green-600",
            )}
            onClick={() => onFeedback(
                messageId,
                "positive",
            )}
        >
            <ThumbsUp className="size-3.5" />
        </Button>
        <Button
            aria-label="Not helpful"
            disabled={disabled}
            size="icon"
            variant="ghost"
            className={generateValidClassNameHandler(
                "size-6 p-0",
                currentFeedback === "negative" && "text-red-600",
            )}
            onClick={() => onFeedback(
                messageId,
                "negative",
            )}
        >
            <ThumbsDown className="size-3.5" />
        </Button>
    </div>
);
